var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5V2H6V5H4V0H16V5H14ZM16 9.5C16.2833 9.5 16.5207 9.404 16.712 9.212C16.904 9.02067 17 8.78333 17 8.5C17 8.21667 16.904 7.979 16.712 7.787C16.5207 7.59567 16.2833 7.5 16 7.5C15.7167 7.5 15.4793 7.59567 15.288 7.787C15.096 7.979 15 8.21667 15 8.5C15 8.78333 15.096 9.02067 15.288 9.212C15.4793 9.404 15.7167 9.5 16 9.5ZM14 16V12H6V16H14ZM16 18H4V14H0V8C0 7.15 0.291667 6.43767 0.875 5.863C1.45833 5.28767 2.16667 5 3 5H17C17.85 5 18.5627 5.28767 19.138 5.863C19.7127 6.43767 20 7.15 20 8V14H16V18ZM18 12V8C18 7.71667 17.904 7.479 17.712 7.287C17.5207 7.09567 17.2833 7 17 7H3C2.71667 7 2.479 7.09567 2.287 7.287C2.09567 7.479 2 7.71667 2 8V12H4V10H16V12H18Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintLayout);
export default __webpack_public_path__ + "static/media/PrintLayout.bef9f2e75cb6d789e0546879c63c2446.svg";
export { ForwardRef as ReactComponent };